<template>
  <div class="h-full w-full overflow-auto overflow-x-hidden">
    <HeaderNavs class="" />
    <Transition
      mode="out-in"
      appear
      enter-active-class="transition-opacity duration-500"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition-opacity duration-300"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
      duration="200"
    >
      <div class="w-full  " :key="$route.fullPath">
        <slot></slot>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { usePricing } from '@/composables/usePricing'

// Initialiser la détection de prix pour toute l'application
const { initZoneDetection } = usePricing()

onMounted(() => {
  initZoneDetection()
})
</script>
